import {
  Box,
  Typography
} from '@mui/material';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withStyles, withTheme } from '@material-ui/core';
import React, { useState } from 'react';
import { TOAST_MESSAGE_SEVERITY_ERROR, TOAST_MESSAGE_SEVERITY_SUCCESS } from 'modules/layout/types';
import { showToast } from 'modules/layout/layout.actions';

import AttachmentsUpload from 'modules/common/attachments/attachmentsUpload.component';
import SpinnerComponent from 'modules/common/spinner.component';
import { deleteVendorDocument, getVendorDocuments, postVendorDocument, updateVendorDocument } from 'modules/authorizations/store/actions/dataManagement.actions';
import { DELETE_VENDOR_DOCUMENT_FAILURE, GET_VENDOR_DOCUMENTS_FAILURE, UPDATE_VENDOR_DOCUMENT_FAILURE } from 'modules/authorizations/store/types/dataManagementTypes';

const styles = (theme) => {
  return {
    row: {
      backgroundColor: theme.palette.common.white,
    },
    accordionStyleContacts: {
      maxWidth: 1050,
    },
    inputGroup: {
      display: 'inline-flex',
      justifyContent: 'space-between',
    },
    root: {
      maxWidth: 170,
      marginRight: 10,
    },
    extRoot: {
      width: 115,
      marginRight: 10,
    },
    primaryContactRow: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      width: '100%',
    },
    primaryText: {
      paddingTop: 12,
      paddingRight: 5,
    },
    newRow: {
      display: 'flex',
      flexDirection: 'column',
      maxWidth: 1050,
    },
    tabBorder: {
      borderLeft: `2px solid ${theme.palette.grey[400]}`,
      marginLeft: theme.spacing(2),
    },
  };
};

const DocumentsCard = (props) => {

  const { vendorId, vendorDocuments, isReadOnly = false } = props;

  const [isUploading, setIsUploading] = useState(false);

  const convertToBase64 = (file) => {
      return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(file); 
  
        fileReader.onload = () => {
          resolve(fileReader.result);
        };
  
        fileReader.onerror = (error) => {
          reject(error);
        };
      });
    };

  const saveFiles = async (filesToSave) => {
    setIsUploading(true);

    try {
      const allPromises = filesToSave.map(async (file) => {
        var base64 = await convertToBase64(file);

        base64 = base64.split(',')[1]; // Remove the data:<contentType>;base64, part

        await props.postVendorDocument({
          base64FileData: base64,
          fileName: file.name,
          contentType: file.type
        }, vendorId);
      });
    
      await Promise.all(allPromises);

      props.showToast('Successfully uploaded attachments', TOAST_MESSAGE_SEVERITY_SUCCESS);
    } catch (error) {
      console.error("Error uploading files:", error);
      props.showToast('Failed to upload attachments, please try again later', TOAST_MESSAGE_SEVERITY_ERROR);
    } finally {
      const docsResp = await props.getVendorDocuments(vendorId);
      if(docsResp.type === GET_VENDOR_DOCUMENTS_FAILURE) {
          props.showToast('Failed to retrieve vendor documents, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR })
      }
      setIsUploading(false);
    }
  }
    
  const updateFile = async (file) => {
    setIsUploading(true);
    const updateFileResp = await props.updateVendorDocument(file, vendorId);
    if (updateFileResp.type === UPDATE_VENDOR_DOCUMENT_FAILURE) {
      props.showToast('Failed to update attachment, please try again later', TOAST_MESSAGE_SEVERITY_ERROR);
    } else {
      props.showToast('Successfully updated attachment', TOAST_MESSAGE_SEVERITY_SUCCESS);
      const docsResp = await props.getVendorDocuments(vendorId);
      if(docsResp.type === GET_VENDOR_DOCUMENTS_FAILURE) {
          props.showToast('Failed to retrieve vendor documents, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR })
      }
    }
    setIsUploading(false);
  };

  const deleteFile = async (file) => {
    setIsUploading(true);
    const deleteFileResp = await props.deleteVendorDocument(file.vendorAttachmentId);
    if (deleteFileResp.type === DELETE_VENDOR_DOCUMENT_FAILURE) {
      props.showToast('Failed to delete attachment, please try again later', TOAST_MESSAGE_SEVERITY_ERROR);
    } else {
      props.showToast('Successfully deleted attachment', TOAST_MESSAGE_SEVERITY_SUCCESS);
      const docsResp = await props.getVendorDocuments(vendorId);
      if(docsResp.type === GET_VENDOR_DOCUMENTS_FAILURE) {
          props.showToast('Failed to retrieve vendor documents, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR })
      }
    }
    setIsUploading(false);
  };

  return (
    <div>
      {isUploading && <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', padding: '10px' }}>
        <Typography variant="subtitle1">Updating Attachments...</Typography>
        <SpinnerComponent/>
      </Box>}

      <AttachmentsUpload 
        saveFiles={saveFiles}
        fileAttachments={vendorDocuments ? vendorDocuments : []}
        isUploading={isUploading}
        updateFile={updateFile}
        deleteFile={deleteFile}
        webViewableText={'Web Viewable'}
        descriptionText={'Description'}
        displayWebViewable={false}
        displayDescription={false}
        isReadOnly={isReadOnly}
      />
    </div>

  );
}; 

export default compose(
  withStyles(styles),
  withTheme,
  connect(null, {
    getVendorDocuments,
    deleteVendorDocument,
    postVendorDocument,
    updateVendorDocument,
    showToast
  }),
)(DocumentsCard);